import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const Operations = createSlice({
    name: "Operations",
    initialState: {
        operationMapData: [],
        operationBarGraphData: [],
        operationTableData: [],
    },
    reducers: {
        ReducerMapData: (state: any, action: any) => {
            state.operationMapData = action.payload;
            return state;
        },
        ReducerBarGraphData: (state: any, action: any) => {
            state.operationBarGraphData = action.payload;
            return state;
        },
        ReducerTableData: (state: any, action: any) => {
            state.operationTableData = action.payload;
            return state;
        },
    },
});


export const {
    ReducerMapData,
    ReducerBarGraphData,
    ReducerTableData
} = Operations.actions;

export default Operations;
